import findAllInTree from "./findAllInTree";
import innerText from "./innerText";

/**
 * @module parse/traverse
 *
 * Module containing functions to traverse and gather information from the tree.
 */
export {
	findAllInTree,
	innerText,
};
